import { render, staticRenderFns } from "./UserActiveTodos.vue?vue&type=template&id=288d3f2c&scoped=true&"
import script from "./UserActiveTodos.vue?vue&type=script&lang=js&"
export * from "./UserActiveTodos.vue?vue&type=script&lang=js&"
import style0 from "./UserActiveTodos.vue?vue&type=style&index=0&id=288d3f2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288d3f2c",
  null
  
)

export default component.exports